import React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { WidgetCard, WidgetEmptyState } from './WidgetCard';
import { buildLineSeries } from './widgetData';

const AreaChartWidget = ({ widget, rows, stacked = false }) => {
  const { title, xField, yField, seriesField, curve, showLegend } = widget.params || {};
  const { labels, series } = buildLineSeries({ rows, xField, yField, seriesField });

  if (!labels.length || !series.length) {
    return (
      <WidgetCard
        title={title || (stacked ? 'Stacked Area' : 'Area')}
        subtitle={seriesField || yField}
        testId={`report-widget-${widget.id || widget.type}`}
      >
        <WidgetEmptyState message="Area chart data is not available yet." />
      </WidgetCard>
    );
  }

  return (
    <WidgetCard
      title={title || (stacked ? 'Stacked Area' : 'Area')}
      subtitle={seriesField || yField}
      testId={`report-widget-${widget.id || widget.type}`}
    >
      <LineChart
        height={240}
        xAxis={[{ data: labels, scaleType: 'point' }]}
        series={series.map((entry) => ({
          data: entry.data,
          label: entry.label,
          area: true,
          stack: stacked ? 'total' : undefined,
          curve: curve || 'monotoneX',
        }))}
        legend={{ hidden: !showLegend }}
      />
    </WidgetCard>
  );
};

export default AreaChartWidget;
